import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { Header } from "@/components/Header";
import { Text } from "@/components/Text";
import { Flex, Img, inDialogModal, IOpenable } from "@/eworkitComponents";
import { CloseButton } from "@/views/components/CloseButton";
import { StyledModal } from "@/views/components/Modal";

import cannotAcceptSvg from "./assets/cannot-accept.svg";

import "./_cannot-accept-request-to-join-modal.scss";

interface ICannotAcceptRequestToJoinModalProps {}

const CannotAcceptRequestToJoinModal: FC<ICannotAcceptRequestToJoinModalProps & IOpenable> = ({ ...openableProps }) => {
  const { t } = useTranslation("session");

  const baseClassName = "cannot-accept-request-to-join-modal";

  return (
    <StyledModal className={baseClassName}>
      <Flex direction="column" margin={["xl"]} innerMargin="lg">
        <Flex justify="space-between">
          <Header size="md" color="black" weight="bold">
            {t("COMPANY.CANNOT_ACCEPT_REQUEST_TO_JOIN_MODAL.HEADER")}
          </Header>
          <CloseButton onClick={openableProps.onClose} />
        </Flex>

        <Flex direction="column" innerMargin="lg">
          <Flex align="center" justify="center">
            <Img className={`${baseClassName}__img`} src={cannotAcceptSvg} />
          </Flex>
          <Text size="md" hjSuppress>
            {t("COMPANY.CANNOT_ACCEPT_REQUEST_TO_JOIN_MODAL.TEXT")}
          </Text>
        </Flex>

        <Flex innerMargin="md" justify="flex-end">
          <Button className={`${baseClassName}__button`} variant="primary" onClick={openableProps.onClose} size="lg">
            {t("COMPANY.CANNOT_ACCEPT_REQUEST_TO_JOIN_MODAL.BUTTON_OK")}
          </Button>
        </Flex>
      </Flex>
    </StyledModal>
  );
};

export const CannotAcceptRequestToJoinDialogModal = inDialogModal(CannotAcceptRequestToJoinModal);
